// extracted by mini-css-extract-plugin
module.exports = {"error":"ikETo"};